import { useMemo, useState } from "react";
import { Button, Card, Label } from "@osago/ui";
import { buildSnippet } from "@/shared/lib/snippet";
import { EMBED_HOST } from "@/shared/config/env";
import { ymEvent, YM } from "@/shared/lib/metrika";
import { useConfigurator } from "../model/configuratorContext";
import { useWidgetConfig } from "../model/useWidgetConfig";

export function SnippetOutput() {
  const config = useWidgetConfig();
  const { companiesCleared } = useConfigurator();
  const [copied, setCopied] = useState(false);

  const snippet = useMemo(() => buildSnippet(EMBED_HOST, config), [config]);

  async function copy() {
    await navigator.clipboard.writeText(snippet);
    ymEvent(YM.COPY);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }

  if (!config.partnerId.trim() || companiesCleared) return null;

  return (
    <Card>
      <div className="mb-3 flex items-center justify-between">
        <Label variant="section" as="h3">
          Код для вставки
        </Label>
        <Button onClick={copy}>{copied ? "Скопировано" : "Скопировать"}</Button>
      </div>
      <pre className="max-h-52 overflow-auto rounded-input bg-canvas p-3 font-mono text-xs leading-relaxed whitespace-pre-wrap break-all text-input-text">
        {snippet}
      </pre>
    </Card>
  );
}
